import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router';
import '@fortawesome/fontawesome-free/css/all.min.css';



const app = createApp(App)

app.use(router)
app.use(ElementPlus)
// 使用 provide 提供全局数据
app.provide('serverUrl', 'https://api.terracode.cn')
//app.provide('serverUrl', 'http://localhost:8080')
app.provide('fileUrl', 'https://api.terracode.cn')
app.mount('#app')


